<template>
  <div ref="itemsContainer" class="component-collections-list" dir=ltr>
    <Carousel
      v-if="(portalGeneralInfo.Skin === 'cloob' || portalGeneralInfo.Skin === 'jabe') && carouselVisibility" 
      :rtl="$store.getters['tenantConfig/isRTL']"
      :auto-width="true"
      :margin="8"
      :lazy-load="true"
      :rewind="true"
      :items="listCount"
      :dots="false">
     <div v-for="(item, index) in items" :key="index">
      <collection-card :item="item" @click="trackGaEvent(item.id)"/>
     </div>
    </Carousel>
    <Carousel
      v-else-if="carouselVisibility"
      :rtl="$store.getters['tenantConfig/isRTL']"
      :auto-width="true"
      :margin="8"
      :loop="true"
      :lazy-load="true"
      :rewind="true"
      :items="3"
      :dots="false">
     <div v-for="(item, index) in items" :key="index">
      <collection-card :item="item" @click="trackGaEvent(item.id)"/>
     </div>
    </Carousel>
  </div>
</template>

<style>
.owl-item {
  padding-bottom: 5px;
}
</style>
<script>
import { mapGetters } from 'vuex'
import CollectionCard from '@/components/CollectionCard.vue'
import Carousel from '@/components/Carousel.vue'

export default {
  name: 'CollectionsList',
  components: {
    CollectionCard,
    Carousel
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      portalConfig: 'tenantDesign/config'
    }),
    portalGeneralInfo () {
      return this.portalConfig.general
    },
    listCount() {
      if (window.innerWidth > 768){
        return 8
      } else {
        return 5
      }
    }
  },
  watch: {
    items () {
      setTimeout( () => {this.carouselVisibility = true}, 500)
    }
  },
  data () {
    return {
      carouselVisibility: false
    }
  },
  methods: {
    trackGaEvent(itemId)
    {
      this.$ga.event('Collection', 'CollectionID#'+itemId)
    }
  }
}
</script>
